// eslint-disable-next-line import/prefer-default-export
export const CS_API_ROLES = {
    APM_READ: 'apm_read',
    ARTICLE_ORDER_READ: 'article_order_read',
    ARTICLE_ORDER_UPDATE: 'article_order_update',
    COMPANY_READ: 'company_read',
    JIRA_READ: 'jira_read',
    PART_CHANGE_ORDER_READ: 'part_change_order_read',
    RELEASE_NOTE_READ: 'release_note_read',
    SERVER_READ: 'server_read',
    SPARE_PART_ARTICLE_READ: 'spare_part_article_read',
    ZABBIX_HISTORY_READ: 'zabbix_history_read',
    ZABBIX_READ: 'zabbix_read',
};
